export enum FilterStatus {
  ACTION_REQUIRED = 'Action required',
  MERGED = 'Merged',
  PENDING = 'Pending',
  DRAFT = 'Draft',
  SAVED = 'Saved',
  DELETED = 'Deleted',
  FAILED = 'Failed',
}

export enum FileStatus {
  DRAFT_INITIALIZED = 'DRAFT_INITIALIZED',
  DRAFT_FAILED = 'DRAFT_FAILED',
  DRAFT_COMPLETED = 'DRAFT_COMPLETED',
  DRAFT = 'DRAFT',
  MERGE_STARTED = 'MERGE_STARTED',
  MERGE_FAILED = 'MERGE_FAILED',
  MERGED = 'MERGED',
  DELETED = 'DELETED',
  SAVED = 'SAVED',
}

export const FileStatusMapping: Record<FilterStatus, FileStatus[]> = {
  'Action required': [FileStatus.DRAFT_COMPLETED],
  Merged: [FileStatus.MERGED],
  Pending: [FileStatus.DRAFT_INITIALIZED, FileStatus.MERGE_STARTED],
  Draft: [FileStatus.DRAFT],
  Saved: [FileStatus.SAVED],
  Deleted: [FileStatus.DELETED],
  Failed: [FileStatus.DRAFT_FAILED, FileStatus.MERGE_FAILED],
};

export interface KitOrder {
  id: string;
  order_number: string;
  display_code: string;
  region: string;
  created_at: string;
  status: 'UNCONFIRMED' | 'CONFIRMED';
  code: string;
  shipping_date: string;
  gs_one_barcode: string;
}

export interface OrderSearchResponse {
  last_id: string;
  last_page: boolean;
  kit_orders: KitOrder[];
  stats: { incomplete_orders: number; complete: number; total: number };
}

/**
 * This refers to a delivery portal "inspection" which
 * is the language used in the designs "e.g. completed inspections"
 */
export interface Inspection {
  delivery_number: string;
  gs_one_barcode: string;
  ignore: boolean;
  location: string;
  kit_in_existing_order: boolean;
  kit_order_status: KitOrder['status'];
  order_already_exists: boolean; // is a duplicate
  region: string;
  set_code: string;
  display_code: string;
  set_found: boolean; // false means the set does not exist in the db
  set_serial: string;
  shipping_date: string;
  status: 'NEW' | 'ONGOING' | 'COMPLETED';
  user_id: string;
  valid_gs_one_barcode: boolean;
}

export interface FileUploadResponse {
  upload_id: string;
  duplicates: Inspection[];
}

export interface FileUploadListResponse {
  upload_id: string;
  total_kit_orders: number;
  filename: string;
  status: FileStatus;
  created_by: string;
  created: string;
  deleted: boolean;
  gs_reference_uri: string;
}

export interface OrderListQuery {
  date_from?: string;
  date_to?: string;
  last_id?: string;
  status?: KitOrder['status'];
}

interface ProceedMergeUploadOrderDataRequest {
  merge: true;
  duplicates: Inspection[];
}

interface CancelMergeUploadOrderDataRequest {
  merge: false;
}

export type MergeUploadOrderDataRequest = ProceedMergeUploadOrderDataRequest | CancelMergeUploadOrderDataRequest;

export interface MergeUploadOrderDataResponse {
  result: string;
  upload_id: string;
  filename: string;
  total_orders_added: number;
}

export interface UploadOrderDataResponseV2 {
  upload_id: string;
  status: FileStatus;
  result: UploadResult;
}

interface UploadResult {
  gs_location: string;
}
